import {BaseWidgetProps} from '../widget-container';
import * as React from 'react';
import { getIdealTextColor } from '@wix/answers-lib';

export type TicketsContainerProps = {
	baseWidgetProps: BaseWidgetProps
};

export class TicketsContainer extends React.Component<TicketsContainerProps, any> {
	innerContent: Element | null;
	state = {
		brandColor: ''
	};

	constructor (props: TicketsContainerProps) {
		super(props);
	}

	componentDidMount () {
		if (window) {
			window.addEventListener('message', this.handleSettingsPostMessage.bind(this));
		}
	}

	componentWillUnmount () {
		if (window) {
			window.removeEventListener('message', this.handleSettingsPostMessage.bind(this));
		}
	}

	componentWillMount () {
		const {appearance} = this.props.baseWidgetProps.widgetConfig;
		this.setState({ brandColor: appearance.brandColor});
	}

	componentDidUpdate () {
		if (this.innerContent && !this.props.baseWidgetProps.isPreview) {
			this.innerContent.scrollTop = 0;
		}
	}

	handleSettingsPostMessage (event: any) {
		const newSettings: any = event.data.previewNewSettings;
		if (newSettings && (newSettings.color !== undefined || newSettings.chatModule !== undefined)) {
			const brandColor = newSettings.color || this.state.brandColor;
			const removeBannerEnabled = ((newSettings.chatModule || {}).chatContentSettings || {}).removeBannerEnabled;
			this.setState({ brandColor, removeBannerEnabled });
		}
	}

	render () {
		const props = this.props;
		const baseWidgetProps = props.baseWidgetProps;
		const translate = baseWidgetProps.translate;
		// const moduleSettings = this.props.baseWidgetProps.widgetConfig.ticketModuleSettings;
		// const title = moduleSettings.title || translate('widget-ng.tickets.hero.default-title');
		const title = translate('widget-ng.tickets.hero.default-title');
		const heroStyle = {
			backgroundColor: this.state.brandColor,
			color: getIdealTextColor(this.state.brandColor)
		};

		const header = (
			<header className='hero-container' style={heroStyle}>
				<div className='hero'>
					<h1 className='main-title'>{title}</h1>
				</div>
			</header>
		);

		const footer = (
			<footer className='footer-container'>
				<a href='http://wixanswers.com' target='_blank'>
					{translate('widget-ng.footer.powerd-by')}<span>Wix Answers</span>
				</a>
			</footer>
		);

		const hideHeader = baseWidgetProps.widgetConfig.modulesConfig.chatEnabled;
		const hideFooter = hideHeader;

		return (
			<div className={`widget-module tickets-container`}>
				{!hideHeader ? header : null}
				<div className={`inner-content`} ref={(ref) => this.innerContent = ref}>
					{props.children}
				</div>
				{!hideFooter ? footer : null}
			</div>
		);
	}
}
